import { createValidator, required } from 'util/validation'

import { MChatAplicacaoModel } from './model-mchat'

export const mChatValidator = createValidator<MChatAplicacaoModel>({
  PERGUNTA_01: required,
  PERGUNTA_02: required,
  PERGUNTA_03: required,
  PERGUNTA_04: required,
  PERGUNTA_05: required,
  PERGUNTA_06: required,
  PERGUNTA_07: required,
  PERGUNTA_08: required,
  PERGUNTA_09: required,
  PERGUNTA_10: required,
  PERGUNTA_11: required,
  PERGUNTA_12: required,
  PERGUNTA_13: required,
  PERGUNTA_14: required,
  PERGUNTA_15: required,
  PERGUNTA_16: required,
  PERGUNTA_17: required,
  PERGUNTA_18: required,
  PERGUNTA_19: required,
  PERGUNTA_20: required,
})
